import axios from 'axios';
import Cache from '~/src/api/requests/cache';
import { stringify } from 'qs';

const CONTENT_API_ENDPOINT = process.env.CONTENT_API_ENDPOINT;

/**
 * Запрос в ApiContent
 */
const axiosContent = axios.create({
    baseURL: CONTENT_API_ENDPOINT,
});

axiosContent.interceptors.request.use(
    (config) => {
        const isErtelecomHost = (/t2.ertelecom.ru\/$/).test(config.baseURL);

        if (!process.browser && isErtelecomHost) {
            const https = require('https');

            config.httpsAgent = new https.Agent({
                rejectUnauthorized: false
            });
        }

        return config;
    },
    (error) => Promise.reject(error),
);

const contentRequest = Object.create(axiosContent);

contentRequest.getWithCache = async(url, options) => {
    let params = {};
    if (options) {
        params = options.params;
        options.paramsSerializer = params => {
            return stringify(params);
        };
    }
    const cache = new Cache(CONTENT_API_ENDPOINT, url, params);
    const dataFromCache = await cache.get();
    if (dataFromCache) {
        return {
            status: 200,
            data: dataFromCache
        };
    } else {
        const result = await axiosContent.get(url, options);
        cache.set(result.data);
        return result;
    }
};
export default contentRequest;
